import type { IsoPoint } from '@modo-vivo/contracts';

export const TABLE_SEATS: Record<number, { seat: IsoPoint; approach: IsoPoint[] }> = {
  1: { seat: { x: 11, y: 7 }, approach: [{ x: 6, y: 18 }, { x: 8, y: 14 }, { x: 10, y: 9 }, { x: 11, y: 7 }] },
  2: { seat: { x: 14, y: 7 }, approach: [{ x: 6, y: 18 }, { x: 10, y: 12 }, { x: 13, y: 8 }, { x: 14, y: 7 }] },
  3: { seat: { x: 17, y: 7 }, approach: [{ x: 6, y: 18 }, { x: 12, y: 11 }, { x: 16, y: 8 }, { x: 17, y: 7 }] },
  4: { seat: { x: 11, y: 10 }, approach: [{ x: 6, y: 18 }, { x: 9, y: 14 }, { x: 10, y: 11 }, { x: 11, y: 10 }] },
  5: { seat: { x: 14, y: 10 }, approach: [{ x: 6, y: 18 }, { x: 11, y: 13 }, { x: 13, y: 11 }, { x: 14, y: 10 }] },
  6: { seat: { x: 17, y: 10 }, approach: [{ x: 6, y: 18 }, { x: 13, y: 12 }, { x: 16, y: 11 }, { x: 17, y: 10 }] },
  7: { seat: { x: 11, y: 13 }, approach: [{ x: 6, y: 18 }, { x: 9, y: 16 }, { x: 10, y: 14 }, { x: 11, y: 13 }] },
  8: { seat: { x: 14, y: 13 }, approach: [{ x: 6, y: 18 }, { x: 11, y: 15 }, { x: 13, y: 14 }, { x: 14, y: 13 }] },
  9: { seat: { x: 17, y: 13 }, approach: [{ x: 6, y: 18 }, { x: 13, y: 15 }, { x: 16, y: 14 }, { x: 17, y: 13 }] },
  10: { seat: { x: 14, y: 16 }, approach: [{ x: 6, y: 18 }, { x: 10, y: 17 }, { x: 12, y: 16 }, { x: 14, y: 16 }] },
};

export const ENTRANCE_POINT: IsoPoint = { x: 6, y: 18 };

export const WAITER_HOME: Record<string, IsoPoint> = {
  'waiter-1': { x: 10, y: 8 },
  'waiter-2': { x: 16, y: 12 },
};
